<template>
    <div class="card">
        <DataTable
            :value="data"
            v-model:selection="selectedItems"
            v-model:filters="filterParams.filters"
            filterDisplay="row"
            paginator
            lazy
            :rows="filterParams.perPage"
            :rowsPerPageOptions="[50, 100, 200]"
            :total-records="total"
            :loading="loading"
            @page="onPage($event)"
            @filter="getData()"
            class="customTable"
            @row-select-all="onSelectAllChange"
            @row-select="onRowSelect"
            @row-unselect="onRowUnselect"
        >
        <template #header>
            <div class="table-header">
                <h5 class="p-m-0">
                    Бібліотека рішень
                </h5>
            </div>
        </template>
            <Column selectionMode="multiple" :class="{'select-all-selected': selectAll}" headerStyle="width: 3rem"></Column>
            <Column field="name" header="Найменування">
                <template #body="slotProps">
                    <InputText class="price_input" v-model="slotProps.data.name" />
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.name.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="client_type" header="Типи клієнтів" headerStyle="width: 400px">
                <template #body="slotProps">
                    <p style="margin: 0px;" v-for="(client_type, key) in slotProps.data.client_types" :key="key">{{ client_type.name }}</p>
                </template>
                <template #filter>
                    <Dropdown style="width: 300px" v-model="filterParams.filters.client_type.value" :options="decisionClientTypes" @change="getData()" optionLabel="name" optionValue="code" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="" header="">
                <template #body="slotProps">
                    <div class="action_btns">
                        <a href="javascript:void(0)" @click.stop="editDecision(slotProps.data)">
                            <i :class="['p-datatable-reorderablerow-handle', 'pi pi-eye']"></i>
                        </a>
                        <a href="#" @click.prevent="() => {selectedItems=[]; selectedItems.push(slotProps.data); deleteItems()}">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                            </svg>
                        </a>
                    </div>
                </template>
            </Column>
        </DataTable>

        <div class="bottom_btns">
            <a href="javascript:void(0)" class="add_file_btn" @click="save()">Зберегти</a>
            <a href="javascript:void(0)" class="add_file_btn main" @click="isAddItems=true">Додати нове рішення</a>
            <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedItems.length" @click="deleteItems()">Видалити</a>
            <a href="javascript:void(0)" class="add_file_btn main disabled" v-else>Видалити</a>
        </div>

        <Dialog v-model:visible="isAddItems" @update:visible="cancelAdd()" id="items-table" header="Форма редагування рішення" :style="{ width: '1000px' }" modal>
            <div class="modal_main_content_container">
                <div class="field_container">
                    <label for="decisionName">Назва:</label>
                    <InputText id="decisionName" class="price_input" placeholder="Назва" v-model="newItem.name" />
                </div>

                <div class="field_container">
                    <label for="decisionClientTypes">Типи клієнтів:</label>
                    <MultiSelect id="decisionClientTypes" v-model="newItem.client_types" :options="decisionClientTypes" optionLabel="name" filter placeholder="Оберіть типи клієнтів" />
                </div>

                <div class="field_container">
                    <label for="decisionDescription">Опис:</label>
                    <Textarea id="decisionDescription" rows="5" placeholder="Опис" v-model="newItem.description" />
                </div>

                <label for="decisionFiles">Документи:</label>

                <DataTable id="decisionFiles" :value="newItem.files" paginator :rows="50" :rowsPerPageOptions="[50, 100, 200]" v-model:selection="selectedFiles" tableStyle="min-width: 50rem" class="productTabTable">
                    <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                    <Column field="url" header="Файл">
                        <template #body="slotProps">
                            <a :href="slotProps.data.url" target="_blank">
                                <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-edf291ce="" style="margin-top: 5px;"><path d="M2.5 0C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0H2.5ZM9.5 7V1.5L15 7H9.5Z" fill="#356EEF" data-v-edf291ce=""></path></svg>
                            </a>
                        </template>
                    </Column>
                    <Column field="file_name" header="Найменування">
                        <template #body="slotProps">
                            {{
                                slotProps.data.file_name
                            }}
                        </template>
                    </Column>
                    <Column field="created_at" header="Додано">
                        <template #body="slotProps">
                            {{ moment(slotProps.data.created_at).format("DD.MM.YYYY HH:mm") }}
                        </template>
                    </Column>
                    <Column field="user_id" header="Ким змінено">
                        <template #body="slotProps">
                            {{ slotProps.data.user.email }}
                        </template>
                    </Column>
                    <Column field="type_id" header="Тип документу">
                        <template #body="slotProps">
                            <select v-model="slotProps.data.type_id">
                                <option disabled :value="null">Оберіть тип файлу</option>
                                <option v-for="(fileType, key) in fileTypes" :key="key" :value="fileType.value">{{ fileType.label }}</option>
                            </select>
                        </template>
                    </Column>
                    <Column field="" header="">
                        <template #body="slotProps">
                            <a href="#" @click.prevent="() => {selectedFiles=[]; selectedFiles.push(slotProps.data); deleteSelectedFiles()}">
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                                </svg>
                            </a>
                        </template>
                    </Column>
                    <template #footer>

                        <div class="modal_btns">
                            <a href="javascript:void(0)" class="add_file_btn" @click="() => {docmodal=true;isAddItems=false;}">Додати файли</a>
                            <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedFiles.length" @click="deleteSelectedFiles()">Видалити обрані файли</a>
                        </div>

                        <template v-if="newItem.selected_files?.length">
                            <div class="added_files_header">
                                <span class="added_files">Буде додано {{ newItem.selected_files.length }} нових файлів</span>
                            </div>
                            <ul class="filelist">
                                <li class="filelist_item" v-for="(item, i) in newItem.selected_files" :key="`file_${i}`">
                                    <div class="file_item">
                                        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.5 0C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0H2.5ZM9.5 7V1.5L15 7H9.5Z" fill="#356EEF"/>
                                        </svg>

                                        <div class="file_item_container">
                                            <div class="file_name">
                                                <select class="file_item_select" v-model="item.type_id">
                                                    <option disabled :value="null">Оберіть тип файлу*</option>
                                                    <option v-for="(fileType, key) in fileTypes" :key="key" :value="fileType.value">{{ fileType.label }}</option>
                                                </select>
                                                {{ item.file.name }} ({{ formatBytes(item.file.size) }})
                                            </div>
                                            <a @click="removeDecisionFile(i)" class="remove_file_btn" title="Remove file">
                                                <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1.5 16C1.5 17.1 2.4 18 3.5 18H11.5C12.6 18 13.5 17.1 13.5 16V4H1.5V16ZM14.5 1H11L10 0H5L4 1H0.5V3H14.5V1Z" fill="#4C5567"/>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <button class="clear-btn" @click="clearFiles">Очистити обрані файли</button>
                        </template>

                    </template>
                </DataTable>

                <label for="productSelect">Специфікація:</label>

                <div id="productSelect" class="files_table_container">
                    <div class="content_row">
                        <select class="sub_group_select" v-model="search_type" @change="searchItems()">
                            <option :value="null" disabled>Тип пошуку</option>
                            <option :value="2">За артикулом</option>
                            <option :value="3">За назвою</option>
                        </select>
                        <div class="search_input_container">
                            <div class="search_input_block">
                                <input class="catalog_search_input" @focus="() => {searchResult = true; }" v-on:keyup="searchItems()" v-model="searchval" placeholder="Пошук" />
                                
                                <svg v-if="!searchResult" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#356EEF"/>
                                </svg>

                                <svg id="close_modal" v-if="searchResult" @click="clearSearch()" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                                </svg>
                            </div>
                            <div class="search_results" v-if="searchResult">
                                <div class="products" v-if="searchProducts.length">
                                    <p class="cat_title" v-for="(product, key) in searchProducts" :key="key" @click.stop="addProduct(product)">{{ product.name }}</p>
                                </div>
                                <p class="cat_title" v-if="!searchProducts.length">Немає результатів</p>
                            </div>
                        </div>
                        <div class="file">
                            <label for="input-file" @click="$refs.excelInput.click()">
                                <i class="pi pi-download"></i> Імпорт з Excel
                            </label>
                            <input type="file" id="excelInput" ref="excelInput" accept=".xls,.xlsx" @change="onExcelSelect" />
                        </div>
                    </div>
                </div>

                <DataTable :value="newItem.products" paginator :rows="50" :rowsPerPageOptions="[50, 100, 200]" v-model:selection="selectedProducts" tableStyle="min-width: 50rem" class="productTabTable">
                    <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                    <Column field="name" header="Найменування">
                        <template #body="slotProps">
                            {{
                                slotProps.data.name
                            }}
                        </template>
                    </Column>
                    <Column field="balance" header="Кількість">
                        <template #body="slotProps">
                            <InputNumber class="qty_input" v-model="slotProps.data.count" inputId="minmax" :min="1" :max="999" fluid />
                        </template>
                    </Column>
                    <Column field="balance" header="Ціна, грн">
                        <template #body="slotProps">
                            {{
                                slotProps.data.price
                            }}
                        </template>
                    </Column>
                    <Column field="" header="">
                        <template #body="slotProps">
                            <a href="#" @click.prevent="() => {selectedProducts=[]; selectedProducts.push(slotProps.data); deleteSelectedProducts()}">
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                                </svg>
                            </a>
                        </template>
                    </Column>
                    <template #footer>
                        <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedProducts.length" @click="deleteSelectedProducts()">Видалити обрані товари</a>
                    </template>
                </DataTable>
            </div>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="addItems()">Зберегти</a>
                    <a v-if="newItem.id && newItem.products?.length" href="#" class="confirm_button_cancel" @click.prevent="getExcel()">
                        <i class="pi pi-external-link"></i>
                        Експорт
                    </a>
                    <a v-if="newItem.id && newItem.products?.length" href="#" class="confirm_button_cancel">Застосувати</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="cancelAdd()">Відмінити</a>
                </div>
            </template>
        </Dialog>

        <Dialog v-model:visible="docmodal" @update:visible="cancelAddFiles()" id="items-table" header="Завантаження файлів" :style="{ width: '500px' }" modal>
            <div class="modal_main_content_container">
                <select class="form_select" v-model="selected_files.type_id">
                    <option disabled :value="null">Оберіть тип файлу*</option>
                    <option v-for="(fileType, key) in fileTypes" :key="key" :value="fileType.value">{{ fileType.label }}</option>
                </select>

                <div class="doc_modal_form_content" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.35 6.04C18.67 2.59 15.64 0 12 0C9.11 0 6.6 1.64 5.35 4.04C2.34 4.36 0 6.91 0 10C0 13.31 2.69 16 6 16H19C21.76 16 24 13.76 24 11C24 8.36 21.95 6.22 19.35 6.04ZM14 9V13H10V9H7L12 4L17 9H14Z" fill="#356EEF"/>
                    </svg>


                    <div class="file_modal_container">
                        <input type="file" 
                            accept="application/pdf,image/x-dwg,application/acad,image/vnd.dwg,image/x-dxf,drawing/x-dwf,application/octet-stream,image/jpeg,image/png,application/vnd.rar,application/x-rar-compressed,application/zip,application/x-zip-compressed,multipart/x-zip,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.dwg,.mp4"
                            @change="onChange"
                            ref="file"
                            style="display: none;"
                            multiple
                        >
                        <a class="modal_btn_link" @click="$refs.file.click()"><p>Натисніть щоб прикріпити файли</p></a>

                        <span class="text_secondary">Формат: pdf, png, jpeg, dwg, fra, ini, zip, txt, a3d, m3d, stp, step, rar, doc, docx, xls, xlsx
                            Загальний розмір файлу до 50 Мб. 
                            Не більше 20 файлів </span>
                    </div>
                </div>

                <div class="added_files_header" v-if="selected_files.files.length">
                    <span class="added_files">Додані файли</span>
                </div>
                <ul class="filelist" v-if="selected_files.files.length">
                    <li class="filelist_item" v-for="(file, i) in selected_files.files" :key="`file_${i}`">
                        <div class="file_item">
                            <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.5 0C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0H2.5ZM9.5 7V1.5L15 7H9.5Z" fill="#356EEF"/>
                            </svg>

                            <div class="file_item_container">
                                <span class="file_name">{{ file.name }} ({{ formatBytes(file.size) }})</span>
                                <a @click="removeFile(selected_files.files.indexOf(file))" class="remove_file_btn" title="Remove file">
                                    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.5 16C1.5 17.1 2.4 18 3.5 18H11.5C12.6 18 13.5 17.1 13.5 16V4H1.5V16ZM14.5 1H11L10 0H5L4 1H0.5V3H14.5V1Z" fill="#4C5567"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="addFiles()">Зберегти</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="cancelAddFiles()">Відмінити</a>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "@/Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import Toast from 'primevue/toast';
import {FilterMatchMode} from "primevue/api";
import FormHelper from '../mixins/form_helper';
import moment from "moment";
import InputNumber from 'primevue/inputnumber';

export default {

    components: {
        DataTable,
        Column,
        InputText,
        Textarea,
        swal,
        Dialog,
        Dropdown,
        MultiSelect,
        Toast,
        InputNumber,
    },
    layout: AppLayout,
    mixins: [FormHelper],
    data() {
        return {
            moment: moment,
            data: [],
            total: 0,
            selectedItems: [],
            filterParams: {
                page: 1,
                perPage: 50,
                filters: {
                    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    client_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
                }
            },
            newItem: {
                name: null,
                description: null,
                client_types: [],
                selected_files: [],
                products: [],
            },
            selected_files: {
                type_id: null,
                files: [],
            },
            loading: false,
            selectAll: false,
            isAddItems: false,
            docmodal: false,
            decisionClientTypes: [],
            fileTypes: [],
            searchval: null,
            showClearInput: false,
            searchResult: false,
            searchProducts: [],
            selectedProducts: [],
            selectedFiles: [],
            search_type: 2,
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        save() {
            axios.post(this.route('api.decision.update'), {data: this.data}).then(result => {
                this.$toast.add({ severity: 'success', summary: 'Успішно оновлено!', detail: '', life: 3000 });
                this.getData()
            });
        },
        addItems() {
            if (this.newItem.name) {
                this.sendData = new FormData();
                this.collectFormData(this.newItem);

                axios.post(this.route('api.decision.update'),
                this.sendData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then(result => {
                    this.newItem = {
                        name: null,
                        description: null,
                        client_types: [],
                        selected_files: [],
                        products: [],
                    }

                    this.isAddItems = false

                    this.$toast.add({ severity: 'success', summary: 'Успіх!', detail: '', life: 3000 });
                    
                    this.getData()
                });
            }
        },
        getData() {
            this.loading = true
            axios.post(this.route('api.decision.list'), this.filterParams).then(result => {
                this.data = result.data.items.data;
                this.total = result.data.items.total;
                this.decisionClientTypes = result.data.decisionClientTypes;
                this.fileTypes = result.data.fileTypes;
                this.loading = false
            });
        },
        deleteItems() {
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані рішення будуть видалені',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.selectedItems = []
                    return
                }

                axios.post(this.route('api.decision.delete'), {data: this.selectedItems})
                    .then((result) => {
                        this.getData()
                        this.selectedItems = []
                        this.$toast.add({ severity: 'success', summary: 'Успішно видалено!', detail: '', life: 3000 });
                    }).catch((error) => {
                        this.selectedItems = []
                        console.log(error);
                        window.scroll(0, 0);
                    })

            });
        },
        deleteSelectedFiles() {
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані файли будуть видалені',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.selectedFiles = []
                    return
                }

                const idsToDelete = this.selectedFiles.map(item => item.id);

                axios.post(this.route('api.decision.files.delete'), {ids: idsToDelete})
                    .then((result) => {
                        this.newItem.files = this.newItem.files.filter(item => !idsToDelete.includes(item.id));

                        this.$toast.add({ severity: 'success', summary: 'Успішно видалено!', detail: '', life: 3000 });
                    }).catch((error) => {
                        console.log(error);
                        window.scroll(0, 0);
                    }).finally(() => {
                        this.selectedFiles = []
                    })

            });
        },

        onPage(event) {
            this.filterParams.page = event.page+1
            this.filterParams.perPage = event.rows
            this.getData()
        },
        onSelectAllChange() {
            if (this.data.length >= this.filterParams.perPage) {
                if (!this.selectAll) {
                    this.selectAll = true;
                    this.selectedItems = this.data
                } else {
                    this.selectAll = false;
                    this.selectedItems = [];
                }
            }
        },
        onRowSelect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = this.selectedItems.length === this.data.length
            }
        },
        onRowUnselect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = false;
            }
        },

        onFileSelect(event) {
            this.selected_files.files = Array.from(event.target.files);
        },

        onExcelSelect(event) {
            this.sendData = new FormData();
            this.collectFormData({file: event.target.files[0]});

            axios.post(this.route('api.decision.import'),
                this.sendData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                })
                .then((result) => {
                    if (result.data?.products.length) {
                        result.data.products.forEach((product, index) => {
                            this.addProduct(product)
                        })
                    } else {
                        this.$toast.add({ severity: 'error', summary: 'Товарів не знайдено', detail: '', life: 3000 });
                    }
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                }).finally(() => {
                    this.$refs.excelInput.value = null;
                })
        },

        clearFiles() {
            this.selected_files.files = []
            this.newItem.selected_files = []
        },

        searchItems() {
            if (this.searchval) {
                this.showClearInput = true;
            } else {
                this.showClearInput = false;
            }
            if (this.searchval && this.searchval.length > 2) {
                axios.post(this.route('api.decision.product.search'), {value: this.searchval, search_type: this.search_type})
                    .then((result) => {
                        this.searchProducts = result.data.products;

                        this.searchResult = true;
                    }).catch((error) => {
                        console.log(error);
                        this.searchResult = true;
                        window.scroll(0, 0);
                    })
            }
        },

        clearSearch() {
            this.searchval = null;
            this.showClearInput = false;
            this.searchResult = false;
            this.searchProducts = []
        },

        addProduct(product) {
            const index = this.newItem.products.findIndex(item => item.id === product.id);
            if (index !== -1) {
                this.newItem.products[index].count += product.count;
            } else {
                this.newItem.products.push(product);
            }

            this.searchval = null;
            this.searchResult = false
            this.searchProducts = []
        },

        deleteSelectedProducts() {
            const idsToDelete = this.selectedProducts.map(item => item.id);
            this.newItem.products = this.newItem.products.filter(item => !idsToDelete.includes(item.id));

            this.selectedProducts = []
        },

        editDecision(item) {
            axios.post(this.route('api.decision.get'), {id: item.id})
                .then((result) => {
                    this.newItem = result.data.item;
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                }).finally(() => {
                    this.isAddItems = true
                })
        },

        cancelAdd() {
            this.isAddItems=false
            this.newItem = {
                name: null,
                description: null,
                client_types: [],
                selected_files: [],
                products: [],
            }
            this.selected_files = {
                type_id: null,
                files: [],
            }

            this.searchval = null;
            this.searchResult = false;
            this.searchProducts = []
        },

        addFiles() {
            if (this.selected_files.type_id) {
                this.docmodal=false
                this.isAddItems=true

                this.selected_files.files.forEach((value, index) => {
                    this.newItem.selected_files.push({
                        type_id: this.selected_files.type_id,
                        file: value,
                    })
                });

                this.selected_files = {
                    type_id: null,
                    files: [],
                }
            }
        },

        cancelAddFiles() {
            this.docmodal=false
            this.isAddItems=true
            this.selected_files = {
                type_id: null,
                files: [],
            }
        },

        getExcel() {
            this.loading = true
            axios.post(this.route('api.decision.get-excel'), {
                decision: this.newItem.id
            })
            .then((response) => {
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.loading = false
            }).catch((error) => {
                this.loading = false
                console.log(error);
                window.scroll(0, 0);
            })
        },

        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains('bg-drop')) {
                event.currentTarget.classList.add('bg-drop');
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.remove('bg-drop');
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange(); // Trigger the onChange event manually
            // Clean up
            event.currentTarget.classList.remove('bg-drop');
        },
        onChange() {
            if (this.$refs.file.files.length) {
                let files = this.$refs.file.files;

                let maxSize = 0;

                this.selected_files.files.forEach((value, index) => {
                    maxSize += value.size;
                });

                for (var i = 0; i < this.$refs.file.files.length; i++) {
                    maxSize += files[i].size;
                    
                    if ((maxSize / 1024 / 1024) <= 50) {
                        this.selected_files.files.push(files[i]);
                    } else {
                        alert('Максимальний розмір усіх доданих файлів - 50MB');

                        return false;
                    }
                }
            }
        },
        removeFile(i) {
            this.selected_files.files.splice(i, 1);
        },
        removeDecisionFile(i) {
            this.newItem.selected_files.splice(i, 1);
        },
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },
        blockNegative(event) {
            if (event.key === '-' || event.key === 'e' || event.key === '+') {
                event.preventDefault();
            }
        }
    }
};
</script>

<style scoped>
.modal_btns {
    display: flex;
    gap: 16px;
}
.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    gap: 10px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.price_input {
    height: 40px!important;
    width: 100%;
    align-items: center;
    display: flex;
}
.check-text input {
  display: none;
}
.check-text svg {
  cursor: pointer;
}
.modal_main_content_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.new_files {
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.new_file {
    display: flex;
    align-items: flex-end;
    gap: 5px;
}
.clear-btn {
    margin-top: 10px;
    max-width: 200px;
}
.files_table {
    width: 100%;
}
.files_table tr td{
    text-align: center;
}
.text_center {
    text-align: center;
}
.content_row {
    display: flex;
    width: 100%;
    gap: 15px;
}
.sub_group_select {
    padding: 12px 16px;
    min-width: 150px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}
.search_input_container {
    position: relative;
    z-index: 3;
    width: 100%;
}

.search_input_container svg {
    position: absolute;
    top: 15px;
    right: 15px;
}

.search_input_block {
    position: relative;
}
.search_input_block svg:hover {
    cursor: pointer;
}

.catalog_search_input {
    padding: 6px 16px;
    padding-right: 40px;
    min-width: 461px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    width: 100%;
}

.catalog_search_input:focus {
    outline: none;
}

.search_results {
    position: absolute;
    top: 48px;
    height: 220px;
    z-index: 1;
    overflow: auto;
    background: #FFFFFF;
    border-radius: 0px 0px 4px 4px;
    border: 1px solid #C8E4FF;
    padding-top: 16px;
    padding-bottom: 16px;
    width: 100%;
    display: flex;
    flex-direction: row;
}

.search_results .cat_title {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 6px 16px;
    margin: 0;
    cursor: pointer;
    width: 100%;
}

.search_results .cat_title:hover {
    background: rgba(200, 228, 255, 0.5);
}

.search_results .main_title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #356EEF;
    padding: 12px 16px;
    margin: 0;
    cursor: pointer;
}

.search_results .show_all_link {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-decoration-line: underline;
    color: #356EEF;
    cursor: pointer;
    padding: 0px 16px;
}

.search_results .products {
    width: 100%;
}

.search_results .products {
    width: 100%;
}
.search_results .cat_title {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 6px 16px;
    margin: 0;
    cursor: pointer;
}

.search_results .cat_title:hover {
    background: rgba(200, 228, 255, 0.5);
}

.zindex0 {
    z-index: 0!important;
}

.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.delete_file_btn {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #FFF;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30);
    display: flex;
    width: 133px;
    height: 40px;
    padding: 12px 30px;
    justify-content: center;
    align-items: center;
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}
.excel_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 203px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}
.action_btns {
    display: flex;
    align-items: center;
    gap: 10px;
}
.doc_modal_form_content {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    border: 2px dashed #CED4DA;
    border-radius: 24px;
    width: 100%;
    height: 200px;
    padding-top: 30px;
    padding-bottom: 30px;
}

.doc_modal_form_content.active {
    flex-direction: revert;
    gap: 16px;
}

.doc_modal_form_content.active .file_modal_container {
    text-align: start;
    justify-content: start;
    align-items: start;
}

.file_modal_container {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.text_secondary{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #8E8F96;
    padding: 0px 20px;
}
.added_files{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #919299;
}

.added_files_header {
    display: flex;
    align-items: flex-start;
    margin-top: 16px;
    margin-bottom: 8px;
}

.filelist {
    padding: 0px;
    margin: 0;
    margin-bottom: 24px;
    overflow: auto;
    max-height: 135px;
}

.docs_filelist {
    width: 100%;
    max-height: 345px;
}

.filelist li {
    list-style: none;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 5px;
    width: 100%;
    padding: 13px;
    background: rgba(126, 170, 255, 0.2);
    border-radius: 4px;
}

.filelist li a {
    cursor: pointer;
}

.file_item {
    display: flex;
    gap: 17px;
    width: 100%;
}

.file_item_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 2px solid #2F80ED;
    padding-bottom: 5px;
}
.modal_btn_link {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-decoration-line: underline;
    color: #1C1C1C;
    cursor: pointer;
}
.form_select {
    padding: 10px 16px;
    width: 100%;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    display: flex;
    align-items: center;
}
.file_item_select {
    max-width: 200px;
    height: auto;
    border: 1px solid #CED4DA;
}
.field_container {
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.file {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.file > input[type='file'] {
  display: none
}
.file > label {
  font-size: 1rem;
  font-weight: 300;
  cursor: pointer;
  outline: 0;
  user-select: none;
  border-style: solid;
  border-radius: 4px;
  border-width: 1px;
  background-color: hsl(0, 0%, 100%);
  color: #356EEF;
  border-color: #356EEF;
  height: 100%;
  width: 150px;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
}

.file > label:hover {
  border-color: hsl(204, 86%, 53%);
  background-color: hsl(204, 86%, 96%);
}

.file > label:active {
  background-color: hsl(204, 86%, 91%);
}
</style>
